import React from "react";

import { useReservationFiltering } from "@/hooks/useReservationFiltering";
import { DateRangePicker } from "@/components/common/DateRangePicker";
import { FilterSingleSelect } from "@/components/common/FilterSingleSelect";
import { COUNTRY_OPTIONS } from "@/components/common/countryOptions";
import {
  GUEST_STATUS_FILTER_DEFAULT,
  RESERVATION_GUEST_STATUS_OPTIONS,
} from "../utils/reservationGuestStatusFilters";
import {
  RESERVATION_STATUS_FILTER_DEFAULT,
  RESERVATION_STATUS_FILTER_OPTIONS,
} from "../utils/reservationStatusFilters";

const COUNTRY_FILTER_OPTIONS = [
  { value: "all", label: "Select a country" },
  ...COUNTRY_OPTIONS,
];

const ReservationFilters = () => {
  const { filters, actions } = useReservationFiltering();

  return (
    <>
      <DateRangePicker
        dateRange={filters.dateRange}
        onDateRangeChange={actions.handleDateRangeChange}
        triggerVariant="new_outline"
      />

      <FilterSingleSelect
        value={filters.statusFilter}
        placeholder="Status"
        className="min-w-[120px] justify-between"
        options={[
          { value: RESERVATION_STATUS_FILTER_DEFAULT, label: "Status" },
          ...RESERVATION_STATUS_FILTER_OPTIONS,
        ]}
        onValueChange={(value) =>
          actions.handleFilterChange(actions.setStatusFilter, value)
        }
      />

      <FilterSingleSelect
        value={filters.guestStatusFilter}
        placeholder="Guest Status"
        className="min-w-[150px] justify-between"
        options={[
          { value: GUEST_STATUS_FILTER_DEFAULT, label: "Guest Status" },
          ...RESERVATION_GUEST_STATUS_OPTIONS.map((status) => ({
            value: status,
            label: status,
          })),
        ]}
        onValueChange={(value) =>
          actions.handleFilterChange(actions.setGuestStatusFilter, value)
        }
      />

      <FilterSingleSelect
        value={filters.countryFilter}
        placeholder="Select a country"
        className="min-w-[170px] justify-between"
        options={COUNTRY_FILTER_OPTIONS}
        onValueChange={(value) =>
          actions.handleFilterChange(actions.setCountryFilter, value)
        }
      />
    </>
  );
};

export default ReservationFilters;
